import { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectSearchMetaRefreshing, selectSearchResultsText } from 'shared/selectors/searchMeta';
import { AdvancedFiltersModalFooter } from 'shared/components/AdvancedFiltersModalFooter';

interface IAdvancedFiltersModalFooterContainerProps {
  onFiltersReset: VoidFunction;
  onFiltersApply: VoidFunction;
}

export const AdvancedFiltersModalFooterContainer: FC<IAdvancedFiltersModalFooterContainerProps> = ({
  onFiltersReset,
  onFiltersApply,
}) => {
  const isSearchMetaRefreshing = useSelector(selectSearchMetaRefreshing);
  const searchButtonText = useSelector(selectSearchResultsText);

  return (
    <AdvancedFiltersModalFooter
      searchButtonText={searchButtonText}
      isCounterRefreshing={isSearchMetaRefreshing}
      onClearClick={onFiltersReset}
      onShowClick={onFiltersApply}
    />
  );
};
